import { Component } from '@angular/core';

@Component({
    // no html, barPageNotFoundGuard is used to trigger oops
    template: '',
    standalone: true,
    selector: 'bar-page-not-found'
})
/** Purpose of component is to be able to trigger the route. */
export class BarPageNotFoundComponent {}
